import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { generatePDF, validatePDFData } from '../../../utils/pdfGenerator';

const PrintActionBar = ({ onPrint, onExportPDF, onEmailShare, onBackToCalculator, loanData, isSampleData = false }) => {
  const [isExporting, setIsExporting] = useState(false);
  const [isSharing, setIsSharing] = useState(false);

  const handlePrint = () => {
    if (onPrint) {
      onPrint();
    } else {
      window.print();
    }
  };

  const handleExportPDF = async () => {
    setIsExporting(true);
    try {
      // Use the new PDF generator if loan data is available
      if (loanData && validatePDFData(loanData)) {
        await generatePDF(loanData);
      } else if (onExportPDF) {
        // Fallback to provided handler
        await onExportPDF();
      } else {
        // Last resort - simulate export
        await new Promise(resolve => setTimeout(resolve, 1500));
        console.log('PDF exported successfully');
      }
    } catch (error) {
      console.error('Export failed:', error);
      // You could add a toast notification here
      alert('PDF export failed. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  const handleEmailShare = async () => {
    setIsSharing(true);
    try {
      if (onEmailShare) {
        await onEmailShare();
      } else {
        // Simulate email sharing
        await new Promise(resolve => setTimeout(resolve, 1000));
        console.log('Email sharing initiated');
      }
    } catch (error) {
      console.error('Email sharing failed:', error);
    } finally {
      setIsSharing(false);
    }
  };

  const handleBackToCalculator = () => {
    if (onBackToCalculator) {
      onBackToCalculator();
    } else {
      window.location.href = '/loan-calculator-dashboard';
    }
  };

  return (
    <div className="bg-white border-b border-gray-200 sticky top-0 z-10 print:hidden">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            <button
              onClick={onBackToCalculator}
              className="flex items-center space-x-2 text-gray-600 hover:text-gray-800 transition-colors"
            >
              <Icon name="ArrowLeft" size={16} />
              <span className="text-sm font-medium">Back to Calculator</span>
            </button>
            
            <div className="h-4 w-px bg-gray-300"></div>
            
            <div className="flex items-center space-x-2">
              <Icon name="FileText" size={16} className="text-gray-500" />
              <span className="text-sm font-medium text-gray-700">
                {isSampleData ? 'Sample Loan Report' : 'Loan Amortization Report'}
              </span>
              {isSampleData && (
                <span className="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-amber-100 text-amber-800">
                  Sample
                </span>
              )}
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <Button
              variant="outline"
              size="sm"
              iconName="Printer"
              iconPosition="left"
              onClick={handlePrint}
            >
              Print
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              iconName="Download"
              iconPosition="left"
              loading={isExporting}
              onClick={handleExportPDF}
            >
              Export PDF
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              iconName="Mail"
              iconPosition="left"
              loading={isSharing}
              onClick={handleEmailShare}
            >
              Email
            </Button>
            
            <Button
              variant="default"
              size="sm"
              iconName="ArrowLeft"
              iconPosition="left"
              onClick={handleBackToCalculator}
            >
              Back to Calculator
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintActionBar;